import { render, staticRenderFns } from "./ContactStatusWidget.vue?vue&type=template&id=0f555d46&scoped=true&lang=pug"
import script from "./ContactStatusWidget.vue?vue&type=script&lang=js"
export * from "./ContactStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./ContactStatusWidget.vue?vue&type=style&index=0&id=0f555d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f555d46",
  null
  
)

export default component.exports